import { gql } from '@apollo/client';

export const MARKETPLACE_ORDERS_SHIPPERS = gql`
    query GetMarketplaceOrdersShippers {
        orders(
            distinct_on: shipper_id
            where: { _and: [{ oms: { _eq: false } }, { order_shipper: { test_acc: { _eq: false } } }] }
        ) {
            order_id
            order_shipper {
                client_id
                business_name
            }
        }
    }
`;

export const MARKETPLACE_ORDERS_BILLING = gql`
    query GetMarketplaceOrdersBilling($where: orders_bool_exp!) {
        results: orders(where: $where, order_by: { created_at: desc }) {
            order_id
            order_status
            order_number
            po_number
            reference_id
            dropoff_name
            dropoff_zip
            delivery_date
            billing_completion_time
            pod
            order_shipper {
                client_id
                business_name
            }
            order_carrier {
                client_id
                business_name
            }
            shipper_rate
            carrier_rate
            middle_mile_shipper_rate
            middle_mile_carrier_rate
            price_breakdown
        }
    }
`;
